<template>
  <a-modal
    :visible="true"
    :width="520"
    centered
    title="Errores"
    :body-style="{ padding: '16px' }"
    :mask-closable="false"
    :keyboard="false"
    @cancel="handleClose"
  >
    <p class="text text--large">{{ errorsInfo }}</p>

    <span class="text"> Corregir los siguientes errores y volver a cargar la importación: </span>

    <custom-scrollbar class="container" height="360px">
      <ul v-if="data.exceptions.length > 0" class="list">
        <h4>Tipo: Excepción</h4>
        <li v-for="item in data.exceptions" :key="item" class="list__item">
          {{ exceptionFormat(item) }}
        </li>
      </ul>
      <ul v-if="data.forgottens.length > 0" class="list">
        <h4>Tipo: Campo olvidados</h4>
        <li v-for="item in data.forgottens" :key="item" class="list__item">
          {{ item }}
        </li>
      </ul>
      <ul v-if="data.unknowns.length > 0" class="list">
        <h4>Tipo: Campo desconocidos</h4>
        <li v-for="item in data.unknowns" :key="item" class="list__item">
          {{ item }}
        </li>
      </ul>
      <ul v-if="data.invalids.length > 0" class="list">
        <h4>Tipo: Valores invalidos</h4>
        <li v-for="item in data.invalids" :key="item" class="list__item">
          {{ item }}
        </li>
      </ul>
    </custom-scrollbar>

    <template v-slot:footer>
      <a-button @click="handleClose">Cerrar</a-button>
    </template>
  </a-modal>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    CustomScrollbar,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
    errorsLength: {
      required: true,
      type: Number,
    },
  },
  computed: {
    errorsInfo() {
      if (this.errorsLength === 1)
        return "Se ha detactado un error al momento de generar la importación";
      return `Se han detectado ${this.errorsLength} errores al momento de generar la importación`;
    },
  },
  methods: {
    handleClose() {
      this.$emit("onCloseModal");
    },
    exceptionFormat(exception) {
      const splitter = "CONTEXT: ";
      if (!exception.includes(splitter)) return exception;
      return exception.split(splitter)[1];
    },
  },
});
</script>

<style lang="sass" scoped>
.text
  color: $gray-9

  &--large
    font-size: $font-medium
    font-weight: 600

.container
  border: $border-normal
  padding: 0 12px
  margin-top: 16px

.list
  color: red
  list-style: none
  padding: 0
  padding-bottom: 4px
  margin-top: 12px
  border-bottom: $border-normal

  &__item
    margin: 8px 0
</style>
